<div class="timeline__caption">
  <ng-content></ng-content>
</div>
